<template>
	<div style="display: flex;justify-content: center;width: 100%;">
		<el-select @clear="clearSelect" clearable size="mini" style="" :value="dataItem.linkIndex" placeholder="设置链接">
			<div v-for="optionsItem in options" :key="optionsItem.value">
				<el-option @click.native="changeSelect(optionsItem.value,dataItem,'main')" :label="optionsItem.label"
					:value="optionsItem.value">
				</el-option>
			</div>
		</el-select>

		<el-dialog append-to-body :close-on-click-modal="false" :title="dataItem.cacheLinkIndex"
			:visible.sync="dialogVisible" width="30%" :before-close="()=>{dialogVisible = false}">
			<el-input @change="changeSearchDialogSearch(dataItem)" :placeholder="'请输入搜索' + dataItem.cacheLinkIndex"
				v-model="dialogSearch">
				<el-button slot="append" icon="el-icon-search"></el-button>
			</el-input>
			<div v-loading="loading">
				<div style="margin-top: 10px;">
					<div v-for="(dialogListItem,dialogListIndex) in dialogList" :key="dialogListIndex">
						<el-radio @input="changeRadio" style="display: flex;align-items: center;padding: 5px;"
							v-model="radio" :label="dialogListIndex" border>
							<div
								style="display: flex;align-items: center;padding: 5px;width: 470px;overflow: hidden;text-overflow:ellipsis; white-space: nowrap;">
								<img v-if="dialogListItem.image_format"
									style="width: 20px;height: 20px;object-fit: cover;"
									:src="dialogListItem.image_format" />
								<span style="margin-left: 10px;">{{dialogListItem.name}}</span>
							</div>
						</el-radio>
					</div>
				</div>

			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button style="background-color: #8C62FF;color: #ffffff;" @click="confirmSelect(dataItem)">确
					定</el-button>
			</span>
		</el-dialog>
		<el-dialog append-to-body :close-on-click-modal="false" title="自定义" :visible.sync="customerVisible" width="30%"
			:before-close="()=>{customerVisible = false}">
			<!-- <el-radio v-model="customerRadio" label="站内链接">站内链接</el-radio>
			<el-radio v-model="customerRadio" label="外部链接">外部链接</el-radio> -->
			<el-input v-model="customerInput" style="margin-top: 20px;" placeholder="请输入内容"></el-input>
			<span slot="footer" class="dialog-footer">
				<el-button @click="customerVisible = false">取 消</el-button>
				<el-button style="background-color: #8C62FF;color: #ffffff;" @click="confirmCustomerSelect(dataItem)">确
					定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getProductsAutocomplete,
		getCategoriesAutocomplete,
		getPagesAutocomplete,
		getPageCategoriesAutocomplete,
		getBrandsAutocomplete,
	} from '../../api/all.js'
	export default {
		props: {
			link: {
				type: Object,
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				dialogSearch: "",
				loading: false,
				customerVisible: false,
				customerInput: "",
				customerRadio: "站内链接",
				radio: "",
				dialogList: [],
				groupType: "main",
				dataItem: {
					linkIndex: "",
					cacheLinkIndex: ""
				},
				dialogVisible: false,
				options: [
					{
						label: "无",
						value: '无'
					},
					{
						label: "商品分类",
						value: '商品分类'
					},
					{
						label: "商品",
						value: '商品'
					},
					{
						label: "热销商品",
						value: '热销商品'
					},
					{
						label: "最新商品",
						value: '最新商品'
					},
					{
						label: "浏览最多",
						value: '浏览最多'
					},
					
					{
						label: "所有商品",
						value: '所有商品'
					},
					{
						label: "首页",
						value: '首页'
					},
					// {
					// 	label: "所有商品",
					// 	value: '所有商品'
					// },
					{
						label: "搜索页面",
						value: '搜索页面'
					},
					{
						label: "品牌列表",
						value: '品牌列表'
					},
					// {
					// 	label: "网站地图",
					// 	value: '网站地图'
					// },
					{
						label: "购物车",
						value: '购物车'
					},
					{
						label: "个人中心",
						value: '个人中心'
					},
					{
						label: "我的收藏",
						value: '我的收藏'
					},
					{
						label: "我的订单",
						value: '我的订单'
					},
					// {
					// 	label: "特定页面",
					// 	value: '特定页面'
					// },
					{
						label: "具体文章",
						value: '具体文章'
					},
					{
						label: "文章分类",
						value: '文章分类'
					},
					// {
					// 	label: "商品品牌",
					// 	value: '商品品牌'
					// },
					// {
					// 	label: "固定链接",
					// 	value: '固定链接'
					// },
					{
						label: "自定义",
						value: '自定义'
					}
				],
			}
		},
		mounted() {
			console.log('mountedselectdItem',this.link)
			if(this.link.cacheLinkIndex) {
				this.dataItem = this.link
			}
		},
		methods: {
			changeRadio(e) {
				console.log('e', e)
				console.log(this.dialogList[e])
			},
			confirmCustomerSelect(dataItem) {
				if (this.customerInput == '') {
					this.$message.error('请输入商品链接')
					return
				}
				dataItem.link = {
					name: this.customerInput,
					type: this.customerRadio
				}
				dataItem.linkIndex = dataItem.cacheLinkIndex + ' - ' + this.customerInput
				this.customerInput = ''
				this.customerVisible = false
				this.$emit('confirmSelect', dataItem)
			},
			changeSearchDialogSearch(dataItem) {
				this.changeSelect(dataItem.cacheLinkIndex, dataItem, this.groupType)
			},
			confirmSelect(dataItem) {
				if (this.radio === '') {
					this.$message.error('请选择选项')
					return
				}
				dataItem.link = this.dialogList[this.radio]
				console.log('dataItem.link',dataItem.link)
				dataItem.linkIndex = dataItem.cacheLinkIndex + ' - ' + dataItem.link.name
				this.radio = ""
				this.dialogList = []
				this.dialogVisible = false

				this.$emit('confirmSelect', dataItem)
				console.log('dataItem', dataItem)
			},

			async searchGoods(api) {
				try {
					this.loading = true
					let wsid = this.$cookies.get("wsid")
					let data = await api({
						wsid,
						name: this.dialogSearch
					})
					this.dialogList = data.data.data
					this.loading = false
				} catch (e) {
					this.loading = false
				}
			},
			clearSelect() {
				this.dataItem.link = {}
				this.dataItem.cacheLinkIndex = ''
				this.dataItem.linkIndex = ''
			},
			async changeSelect(e, dataItem, type) {
				this.groupType = type

				console.log('e', e)
				
				console.log('dataItem', dataItem)
				
				console.log('type', type)
				if (e == '无') {
					dataItem.link = {}
					dataItem.cacheLinkIndex = ''
					dataItem.linkIndex = ''
				}
				if (e == '商品') {
					dataItem.cacheLinkIndex = e
					this.dialogVisible = true
					await this.searchGoods(getProductsAutocomplete)
				}
				if (e == '商品分类') {
					dataItem.cacheLinkIndex = e
					this.dialogVisible = true
					await this.searchGoods(getCategoriesAutocomplete)
				}

				if (e == '特定页面') {
					dataItem.cacheLinkIndex = e
					this.dialogVisible = true
					await this.searchGoods(getPagesAutocomplete)
				}
				if (e == '文章分类') {
					dataItem.cacheLinkIndex = e
					this.dialogVisible = true
					await this.searchGoods(getPageCategoriesAutocomplete)
				}
				if (e == '商品品牌') {
					dataItem.cacheLinkIndex = e
					this.dialogVisible = true
					await this.searchGoods(getBrandsAutocomplete)
				}
				
				if (e == '具体文章') {
					dataItem.cacheLinkIndex = e
					this.dialogVisible = true
					await this.searchGoods(getPagesAutocomplete)
				}

				if (e == '首页') {
					dataItem.link = {
						name: "首页",
						url: ""
					}
					dataItem.linkIndex = '首页'
					dataItem.cacheLinkIndex = e
					this.$emit('confirmSelect', dataItem)
				}
				
				if (e == '热销商品') {
					dataItem.link = {
						name: "热销商品",
						url: "typeProducts/typeHot"
					}
					dataItem.linkIndex = '热销商品'
					dataItem.cacheLinkIndex = e
					this.$emit('confirmSelect', dataItem)
				}
				
				
				if (e == '最新商品') {
					dataItem.link = {
						name: "最新商品",
						url: "typeProducts/typeNew"
					}
					dataItem.linkIndex = '最新商品'
					dataItem.cacheLinkIndex = e
					this.$emit('confirmSelect', dataItem)
				}
				
				if (e == '浏览最多') {
					dataItem.link = {
						name: "浏览最多",
						url: "typeProducts/typevisit"
					}
					dataItem.linkIndex = '浏览最多'
					dataItem.cacheLinkIndex = e
					this.$emit('confirmSelect', dataItem)
				}
				
				
				if (e == '所有商品') {
					dataItem.link = {
						name: "所有商品",
						url: "typeProducts/typeAll"
					}
					dataItem.linkIndex = '所有商品'
					dataItem.cacheLinkIndex = e
					this.$emit('confirmSelect', dataItem)
				}
				
				
				if (e == '搜索页面') {
					dataItem.link = {
						name: "搜索页面",
						url: "search_center"
					}
					dataItem.linkIndex = '搜索页面'
					dataItem.cacheLinkIndex = e
					this.$emit('confirmSelect', dataItem)
				}
				if (e == '个人中心') {
					dataItem.link = {
						name: "个人中心",
						url: "account"
					}
					dataItem.linkIndex = '个人中心'
					dataItem.cacheLinkIndex = e
					this.$emit('confirmSelect', dataItem)
				}
				if (e == '我的收藏') {
					dataItem.link = {
						name: "我的收藏",
						url: "account/wishlist"
						
					}
					dataItem.linkIndex = '我的收藏'
					dataItem.cacheLinkIndex = e
					this.$emit('confirmSelect', dataItem)
				}
				if (e == '个人中心') {
					dataItem.link = {
						name: "个人中心",
						url: "account"
					}
					dataItem.linkIndex = '个人中心'
					dataItem.cacheLinkIndex = e
					this.$emit('confirmSelect', dataItem)
				}
				if (e == '我的订单') {
					dataItem.link = {
						name: "我的订单",
						url: "account/orders"
						
					}
					dataItem.linkIndex = '我的订单'
					dataItem.cacheLinkIndex = e
					this.$emit('confirmSelect', dataItem)
				}
				if (e == '品牌列表') {
					dataItem.link = {
						name: "品牌列表",
						url: "brandsPage",
					}
					dataItem.linkIndex = '品牌列表'
					dataItem.cacheLinkIndex = e
					this.$emit('confirmSelect', dataItem)
				}
				
				if (e == '购物车') {
					dataItem.link = {
						name: "购物车",
						url: "carts",
					}
					dataItem.linkIndex = '购物车'
					dataItem.cacheLinkIndex = e
					this.$emit('confirmSelect', dataItem)
				}

				if (e == '固定链接') {
					dataItem.cacheLinkIndex = e
					this.dialogVisible = true
					this.dialogList = [{
							name: "个人中心",
							url: "account"
						},
						{
							name: "我的收藏",
							url: "/account/wishlist"
						},
						{
							name: "我的订单",
							url: '/account/orders'
						},
						{
							name: "品牌列表",
							url: '/brandsPage'
						}
					]
				}
				if (e == '自定义') {
					dataItem.cacheLinkIndex = e
					this.customerVisible = true
				}

			},
		}
	}
</script>

<style>
</style>